import { render, staticRenderFns } from "./WGModalSecondPage.vue?vue&type=template&id=ec30c006&scoped=true&"
import script from "./WGModalSecondPage.vue?vue&type=script&lang=js&"
export * from "./WGModalSecondPage.vue?vue&type=script&lang=js&"
import style0 from "./WGModalSecondPage.vue?vue&type=style&index=0&id=ec30c006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec30c006",
  null
  
)

export default component.exports